import gql from 'graphql-tag';

const getOrganisationQuery = gql`
query GetOrganisation($organisationId: String!) {
  getOrganisation(organisationId: $organisationId) {
    organisationId
    name
    imageUrl
  }
}
`;

const getOrganisation = (organisationId) => ({
  query: getOrganisationQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: () => ({ organisationId })
});

export default getOrganisation;